"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.Render = function (props) {
  var shouldRender = typeof props.ifTrue === "function" ? props.ifTrue() : props.ifTrue;

  if (shouldRender) {
    var theElement = typeof props.children === "function" ? props.data ? props.children(props.data) : props.children() : props.children;
    return theElement !== undefined ? theElement : null;
  }

  return null;
};